import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useModal } from "../../store/modal/hooks";
import { CommunicationIcon, SuccessIcon } from "../common/Icons";
import { StandardModal } from "./StandardModal";

const Content = styled.div`
  height: ${(props) => props.theme.designHeight(300)}px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SupportSuccess = () => {
  const { t } = useTranslation();
  const { closeModal } = useModal();

  return (
    <StandardModal
      title={t("modal.supportSuccess.title")}
      buttonText={t("modal.supportSuccess.button")}
      handleSubmit={closeModal}
      subtitle={t("modal.supportSuccess.subtitle")}
      titleIcon={CommunicationIcon}
      classnames={"success standard-modal"}
    >
      <Content>
        <SuccessIcon />
      </Content>
    </StandardModal>
  );
};
